import { ButtonLink, OverlayLoader } from '@coop/components';

import { appConfig } from '../../../../appConfig';
import BonusTimeline from '../../../myCoop/components/BonusTimeline/BonusTimeline';
import { useBonusLevelTimelineQuery } from '../../../myCoop/hooks/useBonusLevelTimelineQuery';
import { useIsId26Theme } from '../../hooks/useIsId26Theme';
import styles from './Bonus2026FlyIn.module.scss';

const Bonus2026FlyInBody = () => {
    const timelineQuery = useBonusLevelTimelineQuery();
    const isId26Theme = useIsId26Theme();

    if (timelineQuery.isLoading) {
        return <OverlayLoader isLoading={timelineQuery.isLoading} />;
    }

    return (
        <div className={styles.Body}>
            <div className={styles.BonusSection}>
                <div className={styles.TimelineContainer}>
                    <BonusTimeline.Root
                        data={timelineQuery.data}
                        isError={timelineQuery.isError}
                        headerSlot={
                            <div className={styles.Messaging}>
                                <BonusTimeline.MonthHeader>
                                    {timelineQuery.data?.title}
                                </BonusTimeline.MonthHeader>
                                <BonusTimeline.PreHeadline rotated={isId26Theme}>
                                    {timelineQuery.data?.preHeadline}
                                </BonusTimeline.PreHeadline>
                                <BonusTimeline.Headline>
                                    {timelineQuery.data?.headline}
                                </BonusTimeline.Headline>
                            </div>
                        }
                    />
                </div>
                {appConfig.coopSettings.myCoop.yourCoopUrl && (
                    <div className={styles.Cta}>
                        <ButtonLink
                            fullWidth
                            theme="primary"
                            size="large"
                            href={appConfig.coopSettings.myCoop.yourCoopUrl}
                        >
                            Till Ditt Coop
                        </ButtonLink>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Bonus2026FlyInBody;
